import { Modal } from '@thefarmersfront/kitchen';

import { ModalContentsContainer, ModalLabelValueRow, ModalSection, Table } from '~/components/common';

import {
  getDeliveryAgencyOrderDeliveryInfoColumnDefs,
  getDeliveryAgencyProductNamesColumnDefs,
} from '~/utils/delivery-agency/table';

import type { TypeDeliveryAgencyOrderDetail } from '~/types/delivery-agency.types';

import styles from './DeliveryAgencyOrderDetailModal.module.scss';

const DeliveryAgencyOrderDetailModal = ({
  open,
  data,
  onClose,
}: {
  open: boolean;
  data: TypeDeliveryAgencyOrderDetail;
  onClose: () => void;
}) => {
  const { columnDefs: deliveryInfoColumnDefs } = getDeliveryAgencyOrderDeliveryInfoColumnDefs();
  const { columnDefs: productNamesColumnDefs } = getDeliveryAgencyProductNamesColumnDefs();
  const productNamesData = data.productNames.map((productName) => ({ productName }));

  return (
    <Modal title="배송 주문 상세" size="xlarge" open={open} onConfirm={onClose}>
      <ModalContentsContainer>
        <ModalSection title="주문 정보">
          <ModalLabelValueRow label="주문자명" value={data.orderInfoOutput.ordererName} />
          <ModalLabelValueRow label="수령자명" value={data.orderInfoOutput.receiverName} />
          <ModalLabelValueRow label="연락처" value={data.orderInfoOutput.receiverContact} />
          <ModalLabelValueRow label="기본주소" value={data.orderInfoOutput.primaryAddress} />
          <ModalLabelValueRow label="상세주소" value={data.orderInfoOutput.secondaryAddress || '-'} />
          <ModalLabelValueRow label="수령장소" value={data.orderInfoOutput.deliveryLocation.description} />
          <ModalLabelValueRow label="수령장소 상세" value={data.orderInfoOutput.deliveryLocationDetail || '-'} />
          <ModalLabelValueRow label="출입방법" value={data.orderInfoOutput.entranceMethod.description} />
          <ModalLabelValueRow label="출입방법 상세" value={data.orderInfoOutput.entranceMethodDetail || '-'} />
        </ModalSection>
        <ModalSection title="상품 정보">
          <Table
            className={styles['product-table']}
            data={productNamesData}
            options={{ columnDefs: productNamesColumnDefs }}
          />
        </ModalSection>
        <ModalSection title="배송 정보">
          <Table
            className={styles['table']}
            data={data.shippingLabelInfoOutputs}
            options={{ columnDefs: deliveryInfoColumnDefs }}
          />
        </ModalSection>
      </ModalContentsContainer>
    </Modal>
  );
};

export default DeliveryAgencyOrderDetailModal;
